import React, { Component } from 'react'
import Modal from '../../components/modals/InlineEditingModal'
import '../../css/style.css'

class InlineEditingSaveBtn extends Component {
    constructor(props) {
        super(props)
        this.showModal = this.showModal.bind(this)
    }

    showModal() {
        this.props.changeSaveButtonState()
    }

    getButtonStyle = () => {
        return this.props.disableSaveBtn ? 'btn btn-sm btn-primary disabled inline' : 'btn btn-sm btn-primary inlinenable'
    }


    render() {
        const triggerId = `inlineEditingModalTrigger${this.props.index ?? ''}`
        return (
            <div>
                <button data-cbtrack disabled={this.props.disableSaveBtn} id={triggerId}
                        className={this.getButtonStyle()} aria-haspopup="dialog" tabIndex="0">Revalidate
                </button>

                <Modal
                    triggerId={triggerId}
                    apiAuthHeaders={this.props.apiAuthHeaders}
                    editedStagingData={this.props.editedStagingData}
                    deletedStagingData={this.props.deletedStagingData}
                    request={this.props.request}
                />
            </div>
        )
    }
}

export default InlineEditingSaveBtn